import { TSetItemFn, TGetItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'

import { pagesOrder } from '../config/pages/pageOrder'
import { pagesConfig } from '../config/pages/selectionPages'
import { getItem, setItem, setLastVisitedItem } from '../config/storage'

interface CommonProps<T> {
  key: string
  pageConfig: T
  pagesOrder: PageName[]
  setItem: TSetItemFn
  getItem: TGetItemFn
  setLastVisitedItem: (pageName: PageName) => void
  config: IConfig
}

export function getCommonSurveyPageProps<T>(pageName: PageName): CommonProps<T> {
  const pageConfig = pagesConfig[pageName] as T

  if (!pageConfig) {
    throw Error(`config for ${pageName} is unavailable`)
  }

  return {
    key: pageName,
    pageConfig: pageConfig,
    pagesOrder,
    setItem,
    getItem,
    setLastVisitedItem,
    config: window.config,
  }
}
